import React, { ReactNode } from "react";
import { useSelector } from "react-redux";

import { IgBadge, IgDivider, IgTypography } from "@intelligems/ig-theme";
import { ExperienceStatus } from "@intelligems/ig-types";
import { Box, Grid, useTheme } from "@mui/material";
import { getProductPickerSelectedProducts } from "@src/store/slices/productPicker";
import { theme } from "@src/theme";

import { SelectedProductList } from "./SelectedProductList";

interface ChosenProductsListProps {
  isView?: boolean;
  experienceStatus?: ExperienceStatus;
  dialogActions?: ReactNode[];
}

export const SelectedProductSection = ({
  dialogActions,
  isView,
  experienceStatus,
}: ChosenProductsListProps) => {
  const products = useSelector(getProductPickerSelectedProducts);
  const theme = useTheme();
  return (
    <Grid
      item
      container
      direction={"column"}
      wrap={"nowrap"}
      sx={{
        // borderLeft: `1px solid ${theme.igBorders.core.default}`,
        paddingTop: 5,
        height: "365px",
        // height: "450px",
      }}
    >
      <Grid px={7} item container direction={"row"} columnSpacing={2}>
        <Grid item mr={3}>
          <IgTypography color={theme.palette.text.secondary}>
            Selected
          </IgTypography>
        </Grid>
        <Grid item>
          <IgBadge badgeContent={products.length} color={"accent"} />
        </Grid>
      </Grid>
      <Grid item px={3}>
        <IgDivider spacing={"s"} />
      </Grid>
      <Grid item px={7}>
        <SelectedProductList
          isView={isView}
          experienceStatus={experienceStatus}
          showToolTipText={false}
        />
      </Grid>
      {/*{dialogActions && (*/}
      {/*  <Box*/}
      {/*    sx={{*/}
      {/*      display: "flex",*/}
      {/*      marginTop: "25px",*/}
      {/*      gap: "10px",*/}
      {/*      justifyContent: "flex-end",*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    {dialogActions}*/}
      {/*  </Box>*/}
      {/*)}*/}
    </Grid>
  );
};
